import { Swiper, SwiperSlide } from "swiper/react";
import { Autoplay, Navigation, Pagination } from "swiper";
import "swiper/css";
import "swiper/css/pagination";


import pexel1 from "assets/images/hero/New folder/pexel1.jpg"
import pexel2 from "assets/images/hero/New folder/pexel2.jpg"
import pexel3 from "assets/images/hero/New folder/Home/pexel3.jpg"
import pexel4 from "assets/images/hero/New folder/Home/pexel4.jpg"
import pexel5 from "assets/images/hero/New folder/Home/pexel5.jpg"



import "./carousel.css";
import { useState } from "react";

function ModernCarousel() {
    const slides = [
        // { img: pexel1, title: "Grow Your Business with SalesTrackify", subtitle: "Automate your sales, manage leads efficiently, and close more deals with our smart CRM platform." },
        // { img: pexel2, title: "Track Performance in Real-Time", subtitle: "Get actionable insights, analytics, and reports that help you make data-driven decisions instantly." },
        { img: pexel3, title: "Boost Collaboration with Your Team", subtitle: "Empower your sales team to work smarter, stay connected, and achieve targets faster." },
        { img: pexel4, title: "Save Time with Powerful Automation", subtitle: "Automate repetitive tasks, reminders, and follow-ups so you can focus on closing deals." },
        { img: pexel5, title: "Organize & Manage Your Leads Easily", subtitle: "Capture leads from multiple channels, keep them in one place, and never lose a prospect again." },
    ];

    const [activeIndex, setActiveIndex] = useState(0);
    return (
        <div className="modern-carousel">
            <Swiper
                modules={[Pagination, Navigation]}
                pagination={{ clickable: true }}
                navigation={{
                    prevEl: ".swiper-button-prev-custom",
                    nextEl: ".swiper-button-next-custom",
                }}
                loop={true}
                speed={1200}
                slidesPerView={1}
                centeredSlides={false}
                spaceBetween={0}
                breakpoints={{
                    320: { slidesPerView: 1 },   // mobile
                    768: { slidesPerView: 1 },   // tablet
                    1024: { slidesPerView: 1 },  // desktop
                }}
                onSlideChange={(swiper) => setActiveIndex(swiper.realIndex)}
            >


                {slides.map((slide, idx) => (
                    <SwiperSlide key={idx}>
                        <div className="slide-box">
                            <img src={slide.img} loading="lazy" alt={slide.title} />
                            <div className="overlay"></div>


                            <div className={`slide-text ${activeIndex === idx ? "animate-text" : ""}`}>
                                <h2 className="text-white">{slide.title}</h2>
                                <p>{slide.subtitle}</p>
                            </div>
                        </div>
                    </SwiperSlide>
                ))}
            </Swiper>

            <div className="swiper-button-prev-custom nav-btn left">‹</div>
            <div className="swiper-button-next-custom nav-btn right">›</div>
        </div>
    );
}

export default ModernCarousel;
